var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('shared-outbound-select-members',{attrs:{"members":_vm.members},on:{"selectMember":_vm.selectMember}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }